export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';
import './index.styl'; 

import {bind} from 'kpc';

interface Props {
    content: string
    step: number
    showBottom: boolean
}

const contents = [
    '你好，我是AI小助手，很高兴认识你。',
    '你好，我是AI小助手，我可以帮你总结文档、生成代码，也可以继续输出流式内容。',
    '你好，我是AI小助手，请问您需要什么帮助呢。',
];

export default class extends Component<Props> {
    static template = template;

    static defaults() {
        return {
            content: contents[0],
            step: 0,
            showBottom: false,
        };
    }

    @bind
    retry() {
        const nextStep = (this.get('step') + 1) % contents.length;
        this.set({
            step: nextStep,
            content: contents[nextStep],
            showBottom: false,
        });
    }
}